import { axios } from "@/request/index";
// const COMMONAPI_SHOP = '/api/v1/merchant';
 import { MODE_CONF } from '@/utils/config'

export default {
  // 获取 舱单 船公司
  getCarriers(params) {
    return axios.get(`/ccam/carriers/simple`, params);
  },
  // 获取 舱单 船代
  getAgent(params) {
    return axios.get(`/ccam/carriers/agent`, params);
  },
  // 获取 港口
  getPorts(params) {
    return axios.get(`/ccam/ports/simpleLikeOr`, { params });
  },
  // 获取 包装单位
  getPackage(params) {
    return axios.get(`/ccam/package-units/simpleLikeOr`, { params });
  },
  // 获取 箱型
  getContainer() {
    return axios.get(`/enums/container-type`);
  },
  // 获取 国家
  getCountry(params) {
    return axios.get(`/enums/country`);
  },
  // 获取 金额
  getAccount(params) {
    return axios.get(`/ccam/customs/getAccount`, { params });
  },

  // 提交验证码
  verifySms(params) {
    return axios.get(MODE_CONF.base_code + `/services/verify/send/verifySms`, { params });
  },

  // 获取验证码
  getVrcode() {
    return axios.get(MODE_CONF.base_code + `/services/verify/captcha`);
  },
};
